import React from "react";
import Styles from "./Button.module.css";

export default function Button({
  width,
  height,
  radius = "15px",
  text,
  isGreen,
  outerBg = isGreen ? "#357C09" : "#7E7E7E",
  innerBg = isGreen ? "#18AE00" : "#7E7E7E",
  border = isGreen ? "#61FF00" : "#EEEEEE",
  textStrokeColor = isGreen ? "#61FF00" : "#ACACAC",
  textColor = isGreen ? "#1C4900" : "#3E3E3E",
  largeMobileText,
}) {
  return (
    <div
      className={`${Styles.button}  py-[13px] border flex items-center relative cursor-pointer`}
      style={{
        borderRadius: radius,
        width: width,
        height: height,
        WebkitTextStrokeColor: textStrokeColor,
        color: textColor,
        backgroundColor: outerBg,
        borderColor: border,
      }}
    >
      <div
        className={`bg-[${innerBg}] absolute w-3/4 h-8 rounded-[27px] blur-[7px]`}
      />
      <span
        className={` font-Red-Undead lg:text-xl relative z-10 mx-auto ${
          largeMobileText ? "text-xl" : "text-sm"
        }`}
      >
        {text}{" "}
      </span>
    </div>
  );
}
